// Places whose image the admin sets in Site images (2_server/site_image).
// Each has the bundled file shown until an image is uploaded.
export const SITE_IMAGES = {
  HOME_BACKGROUND: { slot: "home_background", fallback: "/Backdrop.png" },
  HOME_INTRO: { slot: "home_intro", fallback: "/resources/home.png" },
  AUTH: { slot: "auth", fallback: "/auth.png" },
  BOOK_CONSULTANT: {
    slot: "book_consultant",
    fallback: "/resources/bookConsultant/modern-furniture@2x.png",
  },
  ABOUT_GALLERY: {
    slot: "about_gallery",
    fallback: [1, 2, 3, 4, 5, 6, 7].map((n) => `/images/thumbnails/${n}.png`),
  },
};
